<div class="d-flex g-4 lead-details-subtitle flex-wrap align-items-center">
  @if (showTripRequestLabel && (departDate || returnDate || travelers)) {
    <p class="lead-details-subtitle-label bold text-travalign-main" data-id="trip-request-label">
      Trip Request
    </p>
  }
  @if (departDate || returnDate) {
    <div class="d-flex align-items-center g-2">
      <div class="d-flex align-items-center justify-content-center icon-wrapper">
        <img src="assets/icons/calendar_today.svg" alt="calendar" />
      </div>
      <p class="lead-details-subtitle-title text-travalign-main" id="dates">
        {{ departDate }}<ng-container *ngIf="returnDate"> — {{ returnDate }}</ng-container>
      </p>
    </div>
  }
  @if (travelers) {
    <div id="travelers" class="d-flex align-items-center g-2">
      <div class="d-flex align-items-center justify-content-center icon-wrapper">
        <img src="assets/icons/travelers.svg" alt="travelers" />
      </div>
      <p class="lead-details-subtitle-title text-travalign-main" data-id="travelers">
        {{ maxTravelersCount < travelers ? maxTravelersCount + '+' : travelers }} traveler{{
          travelers === 1 ? '' : 's'
        }}
      </p>
    </div>
  }
  @if (from) {
    <div id="from" class="d-flex align-items-center g-2">
      <div class="d-flex align-items-center justify-content-center icon-wrapper">
        <img [width]="16" [height]="16" src="assets/icons/flight_takeoff.svg" alt="flight" />
      </div>
      <p class="lead-details-subtitle-title text-travalign-main" data-id="from">{{ from }}</p>
    </div>
  }
</div>
